export default __webpack_public_path__ + "static/media/tete82.7acaa3e3.png";